import { useEffect } from "react";
import { useCurrentUser } from "../hooks/use-currrent-user";
import { useNavigate } from "react-router-dom";

import { AdoraUser } from "@adora/shared/utils/auth";
import Login from "@adora/shared/components/login";
import Result from "@adora/shared/types/result";
import { resolvePostLoginRedirect } from "@adora/shared";
import { toast } from "sonner";
import { clearReviewSession } from "../components/creative-eval/helpers";

const LoginPage: React.FC = () => {
  const { setUser } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    clearReviewSession();
  }, []);

  const subTitle = "Internal";
  const onLogin = (result: Result<AdoraUser>) => {
    result.forEach((value) => {
      setUser(value);
      const redirectResult = resolvePostLoginRedirect(null, "/");
      if (redirectResult.hadInvalidUrl) {
        toast.error("Invalid navigation link detected. Redirecting to home.");
      }
      navigate(redirectResult.url);
    });
  };

  return <Login subTitle={subTitle} onLogin={onLogin} />;
};

export default LoginPage;
